export default __webpack_public_path__ + "static/media/logo-hbs.ed6c1b80.svg";